<template>
  <div
    :class="{
      w100: fullWidth,
    }"
  >
    <div :dependentComputedProps="{ appConfig }"></div>
    <div
      :class="{
        width80: clientPlatform !== 'Web' && !fullWidth,
        w100: fullWidth,
      }"
    >
      <div
        class="user-address-header left-5"
        @click="handleAddressEdit($event)"
      >
        <img
          :src="staticImgBaseUrl + '/images/global/loc-pin.svg'"
          alt="location-pin"
          v-if="
            (addressHeader || bottomAddressLine) && currentOrderType === 'D'
          "
        />
        <img
          :src="staticImgBaseUrl + '/images/global/takeaway-pin.svg'"
          alt="takeaway-pin"
          v-else-if="
            (addressHeader || bottomAddressLine) && currentOrderType !== 'D'
          "
          class="tk-away"
        />
        <div v-else class="loading-sm"></div>
        <span class="complete-address ml4 lh18 fs-12">
          <span
            v-if="isOnLocationPage && addressHeaderOnLocationPage"
            class="bold"
            >{{ addressHeaderOnLocationPage + " " }}</span
          >
          <span v-else-if="addressHeader" class="bold">{{
            addressHeader + " "
          }}</span>
        </span>
        <i
          class="hkfi-arrow-line fs-12 color-tertiary bold rotate90 pl20 mt-24"
          v-if="!isOnLocationPage"
        ></i>
      </div>
      <div
        class="d-flex"
        :class="{ 'justify-content-between': isOnLocationPage }"
      >
        <div
          class="lh16 comp-address"
          :class="{ pl20: clientPlatform == 'Web' }"
        >
          {{ bottomAddressLine }}
        </div>
        <span
          v-if="currentOrderType !== 'D' && isOnLocationPage"
          @click="changeTakeAwayDineInLocation"
          class="pl8 bold color-tertiary"
          >Change</span
        >
      </div>

      <ask-location
        v-if="!isChangeTriggeredFromTakeawayDinein"
        class="ask-loc"
      ></ask-location>
    </div>
  </div>
</template>

<script>
import AskLocation from "./AskLocation.vue";
import Utility from "./../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { EVENT_CLICK_ADDRESS } from "../helpers/analyticsEvents";
import { OrderTypesFromCode } from "../helpers/orderTypesConstants";

export default {
  name: "HomePageUserAddress",
  props: {
    fullWidth: { required: false, default: false },
  },
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
    };
  },
  components: {
    AskLocation,
  },
  mounted() {
    let currentGPSLocation = LocalStorageFunc.getCurrentGPSLocation();
    this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE);
    if (!currentGPSLocation.footerAddress) {
      this.$store.dispatch(keyMapsAction.SAVE_CURRENT_GPS_LOCATION);
    }
  },
  methods: {
    handleAddressEdit(e) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen();
      EVENT_CLICK_ADDRESS();
    },
    changeTakeAwayDineInLocation() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen({ changeTriggerFromDineinTwy: true });
      EVENT_CLICK_ADDRESS({
        positionWithinSection: 2,
        category: "locality",
      });
    },
    getTimeSpentEventFireTime() {
      return window?._siteProps_?.props?.amplitudeAppLaunchEventFireTime
        ? window?._siteProps_?.props?.amplitudeAppLaunchEventFireTime
        : "3";
    },
  },
  computed: {
    appConfig() {
      // if (this.amplitudeTimeSpentIsNotProcessed) {
      //   this.amplitudeTimeSpentIsNotProcessed = false;
      //   let eventFireTime = this.getTimeSpentEventFireTime();
      //   setTimeout(() => {
      //     setEvents("amplitude", "time_spent", {
      //       eventCategory: "time spent",
      //       fired_after: eventFireTime,
      //       Events_time_stamp: new Date().getTime(),
      //       Page_Name: PageNames.NEXTGEN_HOMEPAGE,
      //     });
      //   }, eventFireTime * 1000); //time in milliseconds
      // }
    },
    locationData() {
      return this.$store.state.Location.locationData;
    },
    currentGPSLocationFooterAddress() {
      let currentGPSLoc = LocalStorageFunc.getCurrentGPSLocation();
      return currentGPSLoc?.footerAddress;
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    addressHeader() {
      if (
        LocalStorageFunc.getSelectedUserAddress() &&
        this.currentOrderType === "D"
      ) {
        return LocalStorageFunc.getSelectedUserAddress()?.customer_address_name;
      } else if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.footerAddress ||
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.homePageAddress
            ?.topAddress ||
          "No Location"
        );
      } else if (
        this.isOnHomePage &&
        this.currentOrderType !== "D" &&
        LocalStorageFunc.getDeliveryTypeStationData() &&
        Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length
      ) {
        return OrderTypesFromCode[this.currentOrderType];
      } else if (
        LocalStorageFunc.getSelectedStore() ||
        this.locationData?.address_alias
      ) {
        return this.locationData.address_alias;
      } else return "No Location";
    },
    addressHeaderOnLocationPage() {
      return OrderTypesFromCode[this.currentOrderType];
    },
    nearestApiTopAddress() {
      return this.$store.state.Location.nearestApiTopAddress;
    },
    currentOrderType() {
      return this.isOnLocationPage
        ? LocalStorageFunc.getSelectedDeliveryType() ||
            this.$store.state.User.currentOrderType
        : this.$store.state.User.currentOrderType;
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    isOnLocationPage() {
      return Utility.isCurrentlyAtUrl("/location");
    },
    isChangeTriggeredFromTakeawayDinein() {
      let queryParams = Utility.getQueryFromUrl();
      return queryParams["changeTriggerFromDineinTwy"] == "true" || false;
    },
    bottomAddressLine() {
      if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.displayAddress ||
          "Exact Location Required!"
        );
      } else if (this.currentOrderType === "D") {
        return (
          LocalStorageFunc.getSelectedUserAddress()?.formatted_address ||
          this.locationData?.complete_address ||
          "Exact Location Required!"
        );
      } else {
        if (
          this.isChangeTriggeredFromTakeawayDinein &&
          LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting
        ) {
          return LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting?.mainText;
        } else {
          return (
            LocalStorageFunc.getSelectedUserAddress()?.formatted_address ||
            this.locationData?.complete_address ||
            LocalStorageFunc.getLastLocationNew()?.[0]?.recent
              ?.displayAddress ||
            "Exact Location Required!"
          );
        }
      }
    },
  },
};
</script>
